import { render, staticRenderFns } from "./ProjectItem.vue?vue&type=template&id=9cf84790&scoped=true"
import script from "./ProjectItem.vue?vue&type=script&lang=js"
export * from "./ProjectItem.vue?vue&type=script&lang=js"
import style0 from "./ProjectItem.vue?vue&type=style&index=0&id=9cf84790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf84790",
  null
  
)

export default component.exports